<!--详情页面-->
<template>
  <el-dialog
    :title="getTitle()"
    :visible.sync="dialogMachiningVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog"
  >
    <div ref="print1" style="width: 100%;margin: 0 auto;">
      <p :style="{display:showtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">{{getTitle()}}</p>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"  class="print-table">
        <tr class="noborder">
          <td align="left" style="width: 90px;">单号：</td>
          <td>
            {{controlData.erpserial}}
          </td>
          <td align="right" style="width: 90px;">入&nbsp;&nbsp;&nbsp;&nbsp;库：</td>
          <td style="width: 180px;">
            {{controlData.cangkuname}}
          </td>
          <td align="right" style="width: 90px;">责任人：</td>
          <td style="width: 180px;">
            {{controlData.customername}}
          </td>
        </tr>
        <tr class="noborder" v-if="isbuy">
          <td>供应商：</td>
          <td>{{pcustomerserial}}  {{pcustomer}}</td>
          <td align="right">供应号：</td>
          <td>
            <el-input v-model="tracknum" size="mini" ref="tracknum" placeholder="请输入供应商单号"
                      onfocus="this.select()"
            ></el-input>
          </td>
          <td align="right">跟踪号：</td>
          <td>
            <el-input v-model="logisticstracknum" size="mini" ref="logisticstracknum" placeholder="请填写跟踪单号"
                      onfocus="this.select()"
            ></el-input>
          </td>
        </tr>
        <tr style="height: 20px"></tr>
        <tr>
          <td colspan="6" style="border:none">
            <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
                   class="query-table">
              <tr>
                <td style="text-align: center;" v-show="showJingPian">R/L</td>
                <td style="text-align: center;">产品名称</td>
                <td style="text-align: center;" v-show="showJingPian">球镜</td>
                <td style="text-align: center;" v-show="showJingPian">柱镜</td>
                <td style="text-align: center;" v-show="showJingJia">型号</td>
                <td style="text-align: center;" v-show="showJingJia">色号</td>
                <td style="text-align: center;">销售单号</td>
                <td style="text-align: center;">采购单号</td>
                <td style="text-align: center;">数量</td>
              </tr>
              <tr v-for="item in tableData">
                <td style="text-align: center;" v-show="showJingPian">{{getPack(item.packagesize,'type',item.formproperty)}}</td>
                <td style="text-align: left;minWidth:150px">{{item.seedname}}<p v-if="item.subseedname" style="padding-left: 20px">{{item.subseedname}}</p></td>
                <td style="text-align: center;" v-show="showJingPian">{{getPack(item.packagesize,'Y')}}</td>
                <td style="text-align: center;" v-show="showJingPian">{{getPack(item.packagesize,'X')}}</td>
                <td style="text-align: center;" v-show="showJingJia">{{getPack(item.packagesize,'M')}}</td>
                <td style="text-align: center;" v-show="showJingJia">{{getPack(item.packagesize,'C')}}</td>
                <td style="text-align: center;">{{item.ordernum}}</td>
                <td style="text-align: center;">{{item.buyordernum}}</td>
                <td style="text-align: center;">{{item.totalnumber}}</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr style="height: 20px"></tr>
        <tr class="noborder">
          <td align="left">报损原因：</td>
          <td colspan="5" style="border: none;height: 30px">
            {{ordername}}<br>
           {{controlData.remark}}
          </td>
        </tr>
        <tr style="height: 20px"></tr>
        <tr class="noborder">
          <td align="left">加工/退货单：</td>
          <td>
            {{controlData.workshopserial}}
          </td>
          <td align="right">录入人：</td>
          <td>
            {{controlData.uname}}
          </td>
          <td align="right">报损日期：</td>
          <td>
            {{controlData.adddate}}
          </td>
        </tr>
        <tr class="noborder" v-if="isbuy">
          <td>说&nbsp;&nbsp;&nbsp;&nbsp;明：</td>
          <td colspan="5">
            <textarea style="width: 100%;height: 60px" v-model="remark"></textarea>
          </td>
        </tr>
      </table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogMachiningVisible = false;">关 闭</el-button>
      <el-button type="primary" @click="handlebaosun" v-if="iscangku" :loading="loading">确认入库</el-button>
      <el-button type="primary" @click="handleBuy" v-if="isbuy" :loading="loading">确认采购</el-button>
      <el-button type="danger" @click="deletebaosun" v-if="showdelete" :loading="loading">删 除</el-button>
      <el-button type="primary" @click="print1">打印</el-button>
      <BuyfromSupplyer ref="BuyfromSupplyer"></BuyfromSupplyer>
      <BuyfromEssilor ref="BuyfromEssilor" @afterEssilorBuy="afterEssilorBuy" :showTPD="showTPD" :buytype="'buy&sale'"></BuyfromEssilor>
    </div>
  </el-dialog>
</template>

<script>
  import {getByERPSerial,removeByERPSerial} from '@/api/set/jxcstoreform';
  import {getBySerial} from '@/api/set/externaldept';
  import {updatebadparts} from '@/api/set/jxcstoreformdetail';
  import BuyfromSupplyer from '../buyagreement/BuyfromSupplyer';
  import {login, createOrder,backOrder} from '@/api/ossi';
  import {detailERPSerial,buyodersavedetail} from '@/api/set/csagreement';
  import {cusandptbyind} from '@/api/set/jxcstore';
  import BuyfromEssilor from '@/components/testorder/buyagreement/BuyfromEssilor'

  export default {
    name: 'BaoSunDetail',
    data() {
      return {
        showTPD:true,
        ssotoken:"",
        mySystem:false,
        website:"",
        userInfoModel:{},
        jxcstoreData:[],
        showtitle1:"none",
        loading:false,
        showJingPian:false,
        showJingJia:false,
        iscangku:false,
        showdelete:false,
        isbuy:false,
        dialogMachiningVisible: false,
        formLabelWidth: '120px',
        controlData: {},
        ordername:'',
        tableData: [],
        tracknum:'',
        logisticstracknum:'',
        pcustomerserial:'',
        pcustomer:'',
        remark:'',
        seedList:[],
        transition:{}
      }
    },
    methods: {
      getPack(packagesize,col,formproperty) {
        var v = '';
        if (packagesize) {
          v = JSON.parse(packagesize)[col];
          if(v==null)
            v='';
          else{
            if(col=='M')
              this.showJingJia=true;
            if(col=='Y')
              this.showJingPian=true;
          }
        }
        if(!v&&col=='type'&&formproperty){
          v = JSON.parse(formproperty)[0][col];
          if(v==null)
            v='';
        }
        return v;
      },
      //删除报损单
      deletebaosun() {
        this.loading=true;
        this.showdelete=false
        removeByERPSerial({
          erpserial: this.controlData.erpserial
        }).then(response => {
          if (response.data.code == 0) {
            this.$emit("bindGrid");
            this.dialogMachiningVisible=false
          }else{
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
          }
        })
      },
      //入坏件库
      handlebaosun(){
        this.loading=true;

        updatebadparts({erpserial: this.controlData.erpserial}).then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: '成功入库！',
              type: 'success',
            })
            this.$emit("bindGrid",true)
          }else{
            this.$message({
              message: '单据已处理！',
              type: 'error',
            })
          }
          this.dialogMachiningVisible=false;
        })
      },
      print1() {
        this.showtitle1 = ""
        this.$nextTick(() => {
          this.$print(this.$refs.print1)
          this.showtitle1 = "none"
        })
      },
      //发起采购
      handleBuy(){
        var SeedInfo='';
        var SeedCodes=';';
        var formsdetail=[];
        for(let i=0;i<this.tableData.length;i++) {
          var SeedCode=this.tableData[i].seedcode
          var items = {};
          items["seedcode"] = SeedCode
          items["seedname"] = this.tableData[i].seedname
          items["P"] = this.tableData[i].totalnumber

          var packagesize = this.tableData[i].packagesize
          if (packagesize) {
            var ps = JSON.parse(packagesize)
            if (ps['X'])
              items["X"] = ps['X']
            if (ps['Y'])
              items["Y"] = ps['Y']
            if (ps['type'])
              items["type"] = ps['type']
          }
          var categorycode=''
          for(let j=0;j<this.seedList.length;j++) {//从原始采购单中取值
            if (this.seedList[j].seedcode == SeedCode) {
              categorycode=this.seedList[j].categorycode
              if(packagesize&&this.seedList[j].packagesize==packagesize){
                if(this.seedList[j]['formproperty']) {
                  var fp = JSON.parse(this.seedList[j]['formproperty']);

                  if (this.tableData[i].formproperty) {
                    var oldFP = JSON.parse(this.tableData[i].formproperty)[0];//坏件单中的属性值

                    if (oldFP.type)
                      fp[0].type = oldFP.type;
                    if (oldFP.A)
                      fp[0].A = oldFP.A;
                  }
                  items["formproperty"] = JSON.stringify(fp);
                }else{
                  items["formproperty"] = this.tableData[i].formproperty;
                }
                items["subseedcode"] = this.seedList[j].subseedcode
                items["subseedname"] = this.seedList[j].subseedname
                break;
              }
            }
          }

          formsdetail.push(items)
          if (SeedCodes.indexOf(';' + SeedCode + ';') == -1) {
            SeedCodes += SeedCode + ';';
            SeedInfo += ';' +SeedCode + ','+categorycode+';';
          }
        }

        var buyForms='['
        for (let j in formsdetail) {
          if (buyForms != '[')
            buyForms += ',';
          buyForms += '{"seedcode":"' + formsdetail[j].seedcode + '",'
          var hastype=false;
          if (formsdetail[j].type) {
            hastype=true;
            buyForms += '"type":"' + formsdetail[j].type + '",'
          }
          if (formsdetail[j].X || formsdetail[j].X == 0)
            buyForms += '"X":"' + parseFloat(formsdetail[j].X).toFixed(2) + '",'
          if (formsdetail[j].Y || formsdetail[j].Y == 0)
            buyForms += '"Y":"' + parseFloat(formsdetail[j].Y).toFixed(2) + '",'
          buyForms += '"Number":' + formsdetail[j].P;
          if (formsdetail[j].formproperty) {
            var fp = JSON.parse(formsdetail[j].formproperty)[0];
            for (let key in fp) {
              if (key == 'X' || key == 'Y' || key == '备注' || (hastype&&key == 'type'))
                continue;

              buyForms += ',"' + key + '":"' + fp[key] + '"';
            }
          }
          buyForms += '}'
        }
        buyForms+=']';

        this.loading=true;
        if (this.ssotoken&&this.ssotoken.indexOf("supplier") > -1) {
          this.transition = {formsdetail: formsdetail, seedcodes: SeedCodes, seedinfo: SeedInfo};
          this.$refs.BuyfromEssilor.show(this.ssotoken, buyForms, this.controlData);
        } else if(this.ssotoken){

          var ckInfo = {};
          for (let i in this.jxcstoreData) {
            if (this.jxcstoreData[i].cangkucode == this.controlData.cangkucode) {
              ckInfo = this.jxcstoreData[i];
            }
          }
          createOrder({
            uname: this.userInfoModel.uname,
            uguid: this.userInfoModel.uguid,
            linkman: ckInfo.applyby,
            linkmantel: ckInfo.tel,
            deliverymode: '配送',
            deliveryaddress: ckInfo.adressdetail,
            formproperty: buyForms,
            remark: '[{"msg":"' + this.remark + '","date":"' + this.CurentTime() + '","uname":"' + this.userInfoModel.uname + '","type":"客户留言"}]',
          }, this.ssotoken,this.mySystem).then(response => {
            if(response.data.price) {
              var priceList = response.data.price;//{商品编码:价格} 只有一个商品
              // for (let j in formsdetail) {
              //   formsdetail[j].gysprice = priceList[formsdetail[j].seedcode]
              // }
            }

            if (response.data.code == 0) {
              this.tracknum = response.data.erpserial;
              this.postBuyData(formsdetail, SeedCodes, SeedInfo, '上游订单已生成，供应商单号：' + this.tracknum);
            } else {
              if (response.data.groupguid) {//打开支付页面
                this.$confirm(response.data.msg, '提示', {
                  confirmButtonText: '生成订单并支付',
                  cancelButtonText: '暂不生成',
                  showClose:false,
                  type: 'warning'
                }).then(() => {
                  this.tracknum = response.data.erpserial;
                  this.postBuyData(formsdetail, SeedCodes, SeedInfo, '上游订单已生成，供应商单号：' + this.tracknum + '，请尽快完成支付！');
                  this.$refs.BuyfromSupplyer.show(this.ssotoken, this.website, response.data, 'pay');
                }).catch(() => {
                  //撤销订单
                  backOrder({erpserial:response.data.erpserial.split(';')[0]}, this.ssotoken,this.mySystem).then(resDel =>{
                    this.loading = false
                  });
                });
              } else {
                this.$message({message: response.data.msg ? response.data.msg : '提交的商品不存在！',type: 'error'})
                this.loading = false
              }
            }
          });

        }else {
          this.postBuyData(formsdetail, SeedCodes, SeedInfo, '保存成功！');
        }
      },
      afterEssilorBuy(buyInfo) {
        this.postBuyData(this.transition.formsdetail, this.transition.seedcodes, this.transition.seedinfo, '提交成功！', buyInfo);
      },
      postBuyData(formsdetail,SeedCodes,SeedInfo,msg,supplydetail) {
        buyodersavedetail({
          jxcforms: JSON.stringify(formsdetail),
          map: JSON.stringify({
            relationserial: this.controlData.erpserial,
            pcustomerserial: this.pcustomerserial,
            pcustomer: this.pcustomer,
            cangkuname: this.controlData.cangkuname,
            cangkucode: this.controlData.cangkucode,
            seedcodelist: SeedCodes,
            seedinfo: SeedInfo,
            address: '',
            linkman: '',
            linkmantel: '',
            remark: this.remark,
            tracknum: this.tracknum.trim(),//供应商单号
            logisticstracknum: this.logisticstracknum.trim(),//跟踪单号
            status: 810,
          }),
          supplydetail:supplydetail
        }).then(response => {
          if (response.data.code == 0) {
            // if (this.ssotoken) {
            //   SSOrelatedOrder({
            //     erpserial: this.tracknum.trim(), parenterpserial: response.data.obj.erpserial, uname: '采购号'
            //   }, this.ssotoken).then(response => {
            //   })
            // }

            this.$message({
              message: msg,
              type: 'success'
            })
            this.$emit('bindGrid',true);
            //this.lookbuyorderdetail(response.data.obj, 1)
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
          }
          this.dialogMachiningVisible = false;
        });
      },
      getTitle() {
        let result = "";
        let temp = localStorage.getItem("hpapi_userInfoModel")
        if (temp) {
          result += JSON.parse(temp).tenantname || ""
        }
        result += "坏件入库单"
        return result
      },
      showbuy(erpserial){//订单岗发起采购
        this.isbuy=true;
        this.show(erpserial,false);
      },
      CurentTime() {
        var now = new Date();

        var year = now.getFullYear();       //年
        var month = now.getMonth() + 1;     //月
        var day = now.getDate();            //日

        var hh = now.getHours();            //时
        var mm = now.getMinutes();          //分

        var clock = year + "-";

        if(month < 10)
          clock += "0";

        clock += month + "-";

        if(day < 10)
          clock += "0";

        clock += day + " ";

        if(hh < 10)
          clock += "0";

        clock += hh + ":";
        if (mm < 10) clock += '0';
        clock += mm;
        return(clock);
      },
      show(erpserial,iscangku) {
        this.showdelete=false
        this.iscangku=false
        this.controlData = {}
        this.tableData = []
        this.loading = false
        this.dialogMachiningVisible = true;
        this.logisticstracknum=''
        this.tracknum=''
        this.pcustomer=''
        this.pcustomerserial=''
        this.remark=''
        this.showJingJia=false
        this.showJingPian=false
        this.ssotoken=''

        getByERPSerial({
          erpserial: erpserial
        }).then(response => {
          if (response.data.code == 0) {
            this.controlData = response.data.main
            this.tableData = response.data.list
            this.ordername = this.tableData[0].ordername
            if (this.ordername == '进货单')
              this.ordername = '供应商多发'
            // else if(this.ordername=='质量问题')
            //   this.ordername='质检问题'

            if (this.controlData.status == 10 && (!this.controlData.casestatus || this.controlData.casestatus == '10')) {//仓库尚未处理，采购岗也没发起采购
              this.showdelete = true
            }
            if (iscangku && this.controlData.status == 10) {
              this.iscangku = true
              this.showdelete = false
            }
            if (this.isbuy) {
              this.showdelete = false
              if (this.controlData.casestatus != '10') {
                this.isbuy=false//已发起过采购
              }else {
                detailERPSerial({erpserial: this.tableData[0].buyordernum}).then(response => {
                  this.pcustomer = response.data.obj.pcustomer;
                  this.pcustomerserial = response.data.obj.pcustomerserial;
                  this.seedList=response.data.list

                  var remark= response.data.obj.remark;
                  if(remark) {
                    try {
                      let temp = JSON.parse(remark.replace(new RegExp("\n", "gm"), ""))
                      remark = '';
                      temp.forEach(item => {
                        if (item.msg && item.msg != '') {
                          if (item.type == '采购留言') {
                            remark += item.msg + ' '
                          }
                        }
                      })
                      this.remark=remark;
                    } catch (ex) {}
                  }

                  //供应商单点登录
                  getBySerial({customerserial:this.pcustomerserial}).then(resCustomer => {
                    if (resCustomer.data.code == 0&&resCustomer.data.obj.usesso==1&&resCustomer.data.obj.ssocode) {
                      if(resCustomer.data.obj.ssocode.indexOf("supplier")>-1){
                        this.ssotoken = resCustomer.data.obj.ssocode;
                      }else {
                        this.mySystem=resCustomer.data.obj.usesso=='2';
                        login({
                          idencode: resCustomer.data.obj.ssocode,
                          tenantid: this.userInfoModel.tenantid
                        },this.mySystem).then(loginres => {
                          if (loginres.data.code == 0) {
                            this.ssotoken = loginres.data.msg;
                            this.website = loginres.data.website;
                          } else {
                            this.$message({message: loginres.data.msg, type: 'error'})
                          }
                        });
                      }
                    }
                  });
                });
              }
            }
          }
        })
      },
    },
    mounted() {
      let temp = localStorage.getItem("hpapi_userInfoModel")
      if (temp) {
        this.userInfoModel=JSON.parse(temp);
      }
      cusandptbyind().then(response => {
        this.jxcstoreData = response.data.obj
      })

    },
    components: {
      BuyfromSupplyer,
      BuyfromEssilor
    }

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }


</style>





// WEBPACK FOOTER //
// src/components/testorder/cstagreement/BaoSunDetail.vue